import React from "react";
import NavBar from "./navigation/NavBar";
import { QueryProvider } from "./providers/QueryProvider";
import { ToastProvider } from "./providers/ToastProvider";

export default function App() {
  return (
    <QueryProvider>
      <ToastProvider />
      <NavBar />
    </QueryProvider>
  );
}